import { useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Tag } from "primereact/tag";
import { SucursalFormDialog } from "../components/dialogs/SucursalFormDialog";
import { EstadoSucursalDialog } from "../components/dialogs/EstadoSucursalDialog";
import { FilterInput } from "../components/shared/FilterInput";
import { getSucursales } from "../../../services/backend/adminService";
import useAdminFetch from "../hooks/useAdminFetch";


const Sucursales = () => {
  const { rows, loading, reload } = useAdminFetch(getSucursales, {
    transform: (response) =>
      Array.isArray(response?.sucursales) ? response.sucursales : [],
  });

  const [visibleEditar, setVisibleEditar] = useState(false);
  const [visibleEstado, setVisibleEstado] = useState(false);
  const [selectedSucursal, setSelectedSucursal] = useState(null);
  const [accionEstado, setAccionEstado] = useState("desactivar");

  const onCancelEditar = () => setVisibleEditar(false);
  const onCancelEstado = () => setVisibleEstado(false);

  const onEditar = (row) => {
    setSelectedSucursal(row);
    setVisibleEditar(true);
  };

  const onToggleEstado = (row) => {
    setSelectedSucursal(row);
    setAccionEstado(row.activa ? "desactivar" : "activar");
    setVisibleEstado(true);
  };

  const header = (
    <div className="flex align-items-center justify-content-between">
      <span className="text-xl font-semibold">Sucursales</span>
    </div>
  );

  const actionTemplate = (rowData) => {
    const activa = rowData.activa;
    return (
      <div className="flex gap-2">
        <Button
          icon="pi pi-pencil"
          aria-label="Editar"
          tooltip="Editar"
          tooltipOptions={{ position: "top" }}
          onClick={() => onEditar(rowData)}
          outlined
        />
        <Button
          icon={activa ? "pi pi-power-off" : "pi pi-power-off"}
          aria-label={activa ? "Desactivar" : "Activar"}
          tooltip={activa ? "Desactivar" : "Activar"}
          tooltipOptions={{ position: "top" }}
          onClick={() => onToggleEstado(rowData)}
          severity={activa ? "warning" : "success"}
          outlined
        />
      </div>
    );
  };

  const estadoTemplate = (rowData) => {
    const activa = rowData.activa;
    return activa ? (
      <Tag value="Activo" severity="success"/>
    ) : (
      <Tag value="Inactivo" severity="warning" />
    );
  };

  return (
    <>
      <div className="py-3">
        <div className="grid">
          <div className="col-12">
            <h4 className="font-bold mb-1">Administración de Sucursales </h4>
            <p className="text-700 text-lg line-height-3 mb-3">
              Aqui puedes configurar las sucursales y sus almacenes.
            </p>
            <DataTable
              value={rows}
              header={header}
              showGridlines
              paginator
              rows={10}
              rowsPerPageOptions={[5, 10, 25, 50]}
              dataKey="almacen"
              stripedRows
              filterDisplay="row"
              scrollable
              scrollHeight="calc(99vh - 370px)"
              paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
              currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} Sucursales"
              loading={loading}
            >
              <Column
                body={actionTemplate}
                header=""
                style={{ width: "10%" }}
              />
              <Column
                field="descripcion"
                header="Comuna"
                sortable
                style={{ width: "25%" }}
                filter
                filterElement={FilterInput}
              />
              <Column
                field="nombre"
                header="Nombre"
                sortable
                style={{ width: "25%" }}
                filter
                filterElement={FilterInput}
              />
              <Column
                field="almacen"
                header="Almacén"
                sortable
                style={{ width: "20%" }}
                filter
                filterElement={FilterInput}
              />
              <Column
                body={estadoTemplate}
                header="Estado"
                style={{ width: "20%" }}
              />
            </DataTable>
          </div>
        </div>
      </div>
      <SucursalFormDialog
        visible={visibleEditar}
        mode="editar"
        sucursal={selectedSucursal}
        onCancel={onCancelEditar}
        onSave={reload}
      />
      <EstadoSucursalDialog
        visible={visibleEstado}
        sucursal={selectedSucursal}
        accion={accionEstado}
        onCancel={onCancelEstado}
        onSave={reload}
      />
    </>
  );
};

export default Sucursales;
